import { format as dateFnsFormat } from 'date-fns';
class AppReactDate {
    date = new Date()
    setDate(d) {
        if (d instanceof Date) {
            this.date = d

        } else if ((typeof d) === 'string') {
            this.date = new Date(d)
        }
    }
    format(date, formatString) {
        return dateFnsFormat(date, formatString)
    }
}

export const container = new AppReactDate()
export const format = (date, formatString) => container.format(date, formatString)
export default () => container.date